import { registerFeature } from "lib/features"
import { MOBILISER } from "library/hubspot/constants.mjs"

export const FEATURE_FLAG_MOBILISER = registerFeature({
    numericalId: 2.1,
    description: "Mobiliser AI mapping",
    name: "Mobiliser",
    id: MOBILISER,
    internalUseOnly: false,
    readyForBeta: true,
    readyForProduction: true,
})
